const ITV_ALMOST_DONE = 'Partiellement terminée';
const ITV_DONE = 'Intervention terminée';
const ITV_IN_PROGRESS = 'En intervention';
const ITV_SCHEDULED = 'Intervention planifiée';
const ITV_REQUESTED = 'DI';

const STATUS_ALMOST_DONE = 'Partiellement Terminée';
const STATUS_END = 'Terminée';
const STATUS_IN_PROGRESS = 'En cours';
const STATUS_PLANIF_ORDO = 'Ordonnancée';

const TECHS_STATUS = [
  {
    color: '#009934',
    icon: 'mdi-calendar-arrow-right',
    label: ITV_DONE,
    planification: STATUS_END,
  },
  {
    color: '#009934',
    icon: 'mdi-calendar-arrow-right',
    label: ITV_ALMOST_DONE,
    planification: STATUS_ALMOST_DONE,
  },
  {
    color: '#009de9',
    // icon: 'mdi-run',
    icon: 'mdi-truck-delivery',
    label: ITV_IN_PROGRESS,
    planification: STATUS_IN_PROGRESS,
  },
  {
    color: '#e07602',
    icon: 'mdi-calendar-clock',
    label: STATUS_PLANIF_ORDO,
    planification: STATUS_PLANIF_ORDO,
    waiting: true,
  },
  {
    color: '#e07602',
    icon: 'mdi-calendar-clock',
    label: ITV_SCHEDULED,
    planification: '',
    waiting: true,
  },
  { icon: null, color: '#fff', label: '', planification: '' },
  { icon: null, color: null, label: '', planification: '' },
  {
    color: '#009989',
    icon: 'mdi-truck-delivery',
    label: ITV_REQUESTED,
    planification: '',
    waiting: true,
  },
];

export default function getStatus(item) {
  if (item.id === 0) return TECHS_STATUS[5];
  if (!item.planification) return TECHS_STATUS[6];
  if (item.reference === 'DI') return TECHS_STATUS[7];
  return (
    TECHS_STATUS.find((tech) => tech.planification === item.planification) ||
    TECHS_STATUS[4]
  );
}

export function transformDate(dateString) {
  const date = new Date(dateString);
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  const tomorrow = new Date(new Date(today).setDate(today.getDate() + 1));

  if (today <= date && tomorrow >= date) {
    const diff = (new Date(date) - new Date()) / (1000 * 60 * 60);
    return {
      diff: Math.floor(diff),
      hour: date.toLocaleTimeString(),
    };
  }
  return { date: date.toLocaleDateString(), hour: date.toLocaleTimeString() };
}
